import { LuCircleAlert, LuCircleCheck, LuInfo, LuTriangleAlert } from 'react-icons/lu'

import { AlertSeverity } from '../../constants/alertContract'
import styles from './AlertSeverityBadge.module.css'

export const SEVERITY_CONFIG: Record<
  AlertSeverity,
  { label: string; icon: React.ReactNode; color: string }
> = {
  [AlertSeverity.URGENT]: {
    label: 'Urgent Alert',
    icon: <LuTriangleAlert size={20} />,
    color: '#BD0404',
  },
  [AlertSeverity.SUCCESS]: {
    label: 'Success Alert',
    icon: <LuCircleCheck size={20} />,
    color: '#6AB62E',
  },
  [AlertSeverity.WARNING]: {
    label: 'Warning Alert',
    icon: <LuCircleAlert size={20} />,
    color: '#EEAB63',
  },
  [AlertSeverity.INFO]: { label: 'Info Alert', icon: <LuInfo size={20} />, color: '#72B9C4' },
}

interface AlertSeverityBadgeProps {
  severity: AlertSeverity
}

export const AlertSeverityBadge = ({ severity }: AlertSeverityBadgeProps) => {
  const { label, icon } = SEVERITY_CONFIG[severity]

  return (
    <span className={`${styles.badge} ${styles[severity]}`} data-testid="alert-severity-badge">
      {icon}
      {label}
    </span>
  )
}
